import { FunctionComponent, useEffect } from 'react';
import { PanelGroup, Panel } from '@cbridge-tools/resizable-panels';
import { useDispatch, useSelector } from '@cbridge-utils/react-redux';
import { SideFilterPanel, ConfigPageLayout, usePersistedPanelLayout, panelLayoutSettingKey } from '@cbridge-modules/layout';
import { UserSettingsPage } from '@cbridge-packages/user-settings';
import { SymbolGroupsAction, selectedSymbolGroupsSelector } from '@cbridge-packages/symbol-groups';
import { CoreSymbolGroupsFilter } from '@cbridge-modules/symbol-groups-filter';
import { ClientSymbolNodesSubNavigation } from '@cbridge-modules/nodes-sub-navigation';
import { StreamsFilter, StreamsFilterAction, selectedStreamIdSelector } from '@cbridge-modules/streams-filter';
import { SymbolMappingFilter, SymbolMappingFilterAction, selectedSymbolMappingFilterSelector } from '@cbridge-modules/symbol-mapping-filter';
import { ServerAction } from '@cbridge-packages/server';
import { SymbolsNavigation } from '../../_navigation/SymbolsNavigation';
import { useCurrentNodeAndServer } from '../useCurrentNodeAndServer';

export const SymbolsClientLayout: FunctionComponent = () => {
  const dispatch = useDispatch();

  const { nodeId, serverId } = useCurrentNodeAndServer();

  useEffect(() => {
    if (serverId) {
      dispatch(ServerAction.load.started({ serverId }));
    }
  }, [dispatch, serverId]);

  useEffect(() => {
    return () => {
      dispatch(ServerAction.destroy());
    };
  }, [dispatch]);

  const selectedStream = useSelector(selectedStreamIdSelector);
  const selectedSymbolGroups = useSelector(selectedSymbolGroupsSelector);
  const selectedSymbolMapping = useSelector(selectedSymbolMappingFilterSelector);

  const hasActiveFilters =
    !!selectedStream || selectedSymbolMapping !== undefined || selectedSymbolGroups?.length > 0;

  const handleClearAllFilters = () => {
    dispatch(StreamsFilterAction.clearSelect());
    dispatch(SymbolGroupsAction.clearSelect());
    dispatch(SymbolMappingFilterAction.clearFilter());
  };

  const sideLayoutProps = usePersistedPanelLayout(panelLayoutSettingKey(UserSettingsPage.ConfigSymbolsClient, 'side'));

  return (
    <ConfigPageLayout settingsKey={UserSettingsPage.ConfigSymbolsClient}>
      <SymbolsNavigation />
      <PanelGroup direction={'vertical'} style={{ flex: '1 0 600px' }} {...sideLayoutProps}>
        <Panel
          id={'list'}
          minSize={20}
          defaultSize={50}
        >
          <ClientSymbolNodesSubNavigation />
        </Panel>
        <SideFilterPanel
          collapsible={true}
          defaultSize={50}
          onClearAllFilters={handleClearAllFilters}
          hasActiveFilters={hasActiveFilters}
        >
          <StreamsFilter nodeId={nodeId} serverId={serverId} />
          <CoreSymbolGroupsFilter />
          {serverId && <SymbolMappingFilter isTradingAware={true} />}
        </SideFilterPanel>
      </PanelGroup>
    </ConfigPageLayout>
  );
};
